module.exports = __webpack_public_path__ + "static/GlitchlessSonyax59-2cfb47ed14c2c4529726cc1b5732eee2.png";